import login from "./api";
import config from "../core/config/config";
import user from "./user";
import auth from "./auth";
import common from "./common";
import home from "./home";
import dot from "../common/js/dot/index";
import FileUpload from "./upload";

export default {
    getImageUrl(url) {
        if (!url) {
            return './static/head.jpg';
        }
        return config.getImgBase() + url
    },
    getImageUpUrl() {
        return config.getImgBase()
    },

    ...login,
    ...user,
    ...auth,
    ...common,
    ...home,
    ...dot,
    FileUpload
};